@if (initialized) {
  @if (!clientStatusService.isMobile && stationIdentifierFromURL == null) {
    <div class="sac-client-container">
      <sc-flex vertical fitHeight stretchContent>
        <app-sac-header-container [sacClientContext]="sacClientContext"
        (structureSelected)="onStructureSelected($event)"></app-sac-header-container>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-flex-fitting-content vertical class="content-area">
          @if (currentStructure != null) {
            <sc-flex fitHeight stretchContent>
              <sc-flex-fitting-content>
                <app-sac-stations [sacClientContext]="sacClientContext" [dashboardContext]="dashboardContext"
                  [sacStructure]="currentStructure" (selectionChanged)="handleSelectionChange($event)">
                </app-sac-stations>
              </sc-flex-fitting-content>
              <sc-content-spacer></sc-content-spacer>
              @if (sacClientContext.showTransports) {
                <app-sac-transports
                  [selection]="selection"
                  [sacClientContext]="sacClientContext" [dashboardContext]="dashboardContext"
                  [refreshTrigger]="forceTransportListReload">
                </app-sac-transports>
              }
            </sc-flex>
          }
        </sc-flex-fitting-content>
      </sc-flex>
    </div>
  }
  @if (!clientStatusService.isMobile && stationIdentifierFromURL != null) {
    <app-sac-station-tablet [station]="selection?.station"></app-sac-station-tablet>
  }
  @if (clientStatusService.isMobile) {
    <app-mobile-sac></app-mobile-sac>
  }
}
